import React from 'react'
import {
  useErrors,
  DefaultFormErrors,
  useUpdateCompany,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'
import { useForm } from 'react-hook-form'
import {
  BillingAddressForm,
  BillingAddressFormData,
} from '../BillingAddressForm'
import { Button } from '../../Button'
import styled from 'styled-components'
import { FormError } from '../../FormError'

type EditBillingAddressProps = {
  data: any
  onSuccess: () => void
  onCancel: () => void
}

export const EditBillingAddress = ({
  data,
  onSuccess,
  onCancel,
}: EditBillingAddressProps) => {
  const [updateBillingAddress, { error }] = useUpdateCompany(onSuccess)
  const { errorMessages, company, cancel, save } = useGlobalLabels()
  const apiErrors = useErrors<DefaultFormErrors>(error, {
    default: errorMessages?.somethingWentWrong,
  })

  const getCustomField = (fieldName: string) => {
    const customFields = data.custom as { field: string; value: string }[]

    return (
      customFields?.find((customField) => customField.field === fieldName)
        ?.value || ''
    )
  }

  const onSubmit = (formData: BillingAddressFormData) => {
    updateBillingAddress({
      id: data._id,
      dto: {
        streetName: formData.companyAddress,
        countryCode: 'BG',
        company: {
          companyName: formData.company,
          vatId: formData.vatNumber,
          companyId: formData.uic,
          companyPerson: formData.companyPerson,
        },
        isDefaultBillingAddress: formData.isDefaultBillingAddress,
        custom: [
          {
            value: formData.mol,
            field: 'mol',
          },
        ],
      },
    })
  }

  const { control, errors, handleSubmit } = useForm<BillingAddressFormData>({
    defaultValues: {
      uic: data.company.companyId,
      vatNumber: data.company.vatId,
      company: data.company.companyName,
      companyPerson: data.company.companyPerson,
      mol: getCustomField('mol'),
      companyAddress: data.streetName,
      isDefaultBillingAddress: data.isDefaultBillingAddress,
    },
  })

  const buttonDisabled = Boolean(Object.keys(errors).length)

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <BillingAddressForm control={control} errors={errors} />
      <SubmitWrapper>
        <Button
          type="button"
          borderRadius="small"
          variant="green"
          bordered
          onClick={onCancel}
        >
          {cancel}
        </Button>

        <Button
          disabled={buttonDisabled}
          borderRadius="small"
          className="ml-4"
          variant={buttonDisabled ? 'disabled' : 'green'}
        >
          {save}
        </Button>
        <FormError errors={apiErrors} fieldName="default" />
      </SubmitWrapper>
    </form>
  )
}

const SubmitWrapper = styled.div.attrs({
  className: 'mt-5 pt-5',
})`
  border-top: 1px solid ${({ theme }) => theme.palette.lightgrey};
  display: flex;
  justify-content: flex-end;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    & button {
      width: 21% !important;
    }
  }
`
